export function OutlineProveedorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9983 15.998H19.003C20.107 15.998 20.9998 16.8908 20.9998 17.9948V20.9996H11.0015V17.9948C11.0015 16.8908 11.8943 15.998 12.9983 15.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9985 7.24804V8.00164C18.9073 8.07364 18.7537 8.18404 18.5473 8.29924C18.0529 8.59204 17.2561 8.94724 16.2337 8.99044C16.1569 8.99524 16.0753 9.00004 15.9937 9.00004C15.9121 9.00004 15.8305 9.00004 15.7537 8.99044C14.7697 8.94244 14.0017 8.61604 13.5073 8.33284C13.2721 8.20324 13.0993 8.07844 12.9985 8.00164V7.24804C12.9985 5.59204 14.3377 4.25285 15.9937 4.24805H15.9985C16.8241 4.24805 17.5777 4.58405 18.1201 5.12645C18.6625 5.66884 18.9985 6.42244 18.9985 7.24804Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9986 8.00195H11.9954"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9919 8.00195H18.9983"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9985 9.99802C18.9985 11.654 17.6545 12.998 15.9985 12.998C14.3425 12.998 12.9985 11.654 12.9985 9.99802C12.9985 9.37883 13.1857 8.80763 13.5073 8.33243C14.0017 8.61563 14.7697 8.94203 15.7537 8.99003C15.8305 8.99483 15.9121 8.99963 15.9937 8.99963C16.0753 8.99963 16.1569 8.99963 16.2337 8.99003C17.2561 8.94683 18.0529 8.59163 18.5473 8.29883C18.7633 8.54843 18.9985 9.01403 18.9985 9.99802Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9919 15.998V20.9996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9954 15.998V20.9996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9934 3V5.99999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M3 3H9.99359"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.00195H7.99199"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.998H9.99359"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
